import { render, staticRenderFns } from "./LessonExamQuestion.vue?vue&type=template&id=2392ceb4&scoped=true&"
import script from "./LessonExamQuestion.vue?vue&type=script&lang=js&"
export * from "./LessonExamQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LessonExamQuestion.vue?vue&type=style&index=0&id=2392ceb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392ceb4",
  null
  
)

export default component.exports